import React, { Component } from "react";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { ToastContainer, ToastStore } from "react-toasts";
import MetaTags from "react-meta-tags";
import ContactUs from "./new-components/contact-us";
import SendUsMessages from "./new-components/form/send-us-message/index";
import ContactUsStyles from "./ContactUs.css";
import FormGroupStyles from "./components/FormGroup.css";

import WarningMessage from "./components/WarningMessage";

/* eslint-disable import/no-webpack-loader-syntax */

import FacebookIcon from "-!svg-react-loader!./icons/connect-facebook.svg";
import LinkedInIcon from "-!svg-react-loader!./icons/connect-linkedin.svg";
import InstragramIcon from "-!svg-react-loader!./icons/connect-instragram.svg";

import utilities from "./components/Utilities";
let Utilities = new utilities();


const contactStyle = {
    display: 'grid',
    gridGap: '25px',
    gridTemplateColumns: '1fr 1fr',
    paddingBottom: '60px',
}
class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      name: "",
      email: "",
      message: "",
      responseSuccess: false,
      response: "",
      isLoggedIn: false,
      buttonEnabled: true,
      definitons: {}
    };
  }

  disableButton = () => {
    this.setState({ buttonEnabled: false });
  };
  enableButton = () => {
    this.setState({ buttonEnabled: true });
  };

  onInputChange = e => {
    let modifiedField = e.target.id;
    let modifiedFieldValue = e.target.value;

    let state = { ...this.state };
    state[modifiedField] = modifiedFieldValue;

    this.setState(state);
  };

  handleChange = (name, value) => {
    let state = this.state;
    state[name] = value;
    this.setState({ state });
  };

  submitForm = e => {
    this.setState({
      response: "",
      responseSuccess: false
    });

    let isValid = true;

    console.log(this.state);

    let enteredName = "";

    if (!this.state.name) {
      enteredName = this.state.firstName + " " + this.state.lastName;
    }

    if (
      (this.state.name.trim() === "" && enteredName.trim() === "") ||
      this.state.email.trim() === "" ||
      this.state.message.trim() === ""
    ) {
      isValid = false;
    }

    if (!isValid) {
      this.setState({
        response: "All fields are required",
        responseSuccess: false
      });
    } else {
      if (e.target.getAttribute("data-enabled") !== "true") {
        return;
      }

      this.disableButton();

      window.globalVars.server.api({
        method: "post",
        url: "api/contact/submit",
        data: {
          name: enteredName || this.state.name,
          email: this.state.email,
          message: this.state.message
        },
        then: function(res) {
          this.setState({
            response:
              "Thank you for your message, our team will get back to you shortly.",
            message: "",
            responseSuccess: true
          });

          document.getElementById("message").value = "";

          this.enableButton();
        }.bind(this),
        catch: function(e) {
          this.setState({
            response: "Error",
            responseSuccess: false
          });

          this.enableButton();
        }.bind(this)
      });
    }
  };

  componentDidMount() {
    document.title =
      window.globalVars.pageTitleBefore +
      "Contact Us" +
      window.globalVars.pageTitleAfter;
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

    let user = JSON.parse(localStorage.getItem("user"));
    if (!Utilities.isENU(user)) {
      this.setState({
        isLoggedIn: true,
        name: user.firstName + " " + user.lastName,
        email: user.email
      });
    }

    let defintions = window.globalVars.definitons;
    let defintionsAssociative = {};

    if (!Utilities.isENU(defintions)) {
      for (var i = 0; i < defintions.length; i++) {
        let type = defintions[i].type;
        if (
          [
            "hdiw-title",
            "hdiw-subhead",
            "hdiw-feature-1-title",
            "hdiw-feature-1-description",
            "hdiw-feature-2-title",
            "hdiw-feature-2-description",
            "hdiw-feature-3-title",
            "hdiw-feature-3-description",
            "hdiw-feature-4-title",
            "hdiw-feature-4-description",
            "intro-title",
            "intro-description",
            "intro-description-2",
            "wcu-title",
            "wcu-feature-1-title",
            "wcu-feature-1-description",
            "wcu-feature-2-title",
            "wcu-feature-2-description",
            "wcu-feature-3-title",
            "wcu-feature-3-description",
            "wcu-feature-4-title",
            "wcu-feature-4-description",
            "contact-us",
            "contact-us-telephone-number",
            "contact-us-email",
            "contact-us-subhead",
            "facebook-link",
            "instagram-link",
            "linkedin-link"
          ].indexOf(type) !== -1
        ) {
          defintionsAssociative[type] = defintions[i].valueStr;
        }
      }
    }
    console.log(defintionsAssociative, 11111)
    this.setState({
      definitons: defintionsAssociative
    });
  }

  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.submitForm(e);
    }
  };

  render() {
    return (
      <div className='contact-us-container'>
        <MetaTags>
          <meta
            id='meta-description'
            name='description'
            content={
              window.region === "SG"
                ? "For any enquiries relating to orders or careers, please reach out to us by phone, email or LiveChat."
                : "For any enquiries relating to orders please complete our online form and we'll get back to you within 24 hours."
            }
          />
          <meta name='robots' content='index' />
          <meta name='googlebot' content='index' />
        </MetaTags>
        {/*<div className='main-container'>*/}
        {/*  <div className='contact-us-info'>*/}
        {/*    <h1>Contact Us</h1>*/}
        {/*    <p>*/}
        {/*      We’re here to help and answer any question you might have. During*/}
        {/*      our normal operating hours you can expect a reply within a couple*/}
        {/*      of hours.*/}
        {/*    </p>*/}
        {/*    {window.region === "SG" && (*/}
        {/*      <div className='field'>*/}
        {/*        <h3>Email us: </h3>*/}
        {/*        <a href='mailto:hello@frameit.com.sg' target='_blank'>*/}
        {/*          hello@frameit.com.sg*/}
        {/*        </a>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*    {window.region === "MY" && (*/}
        {/*      <div className='field'>*/}
        {/*        <h3>Email us: </h3>*/}
        {/*        <a href='mailto:hello@frameit.my' target='_blank'>*/}
        {/*          hello@frameit.my*/}
        {/*        </a>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*    {window.region === "SG" && (*/}
        {/*      <div className='field'>*/}
        {/*        <h3>Call or Whatsapp:</h3>*/}
        {/*        <a href='tel:+65 8798 6867'>+65 8798 6867</a>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*    <div className='field'>*/}
        {/*      <h3>Working hours: </h3>*/}
        {/*      <p>Mon - Fri, 10AM - 6PM</p>*/}
        {/*    </div>*/}
        {/*    {window.region === "SG" && (*/}
        {/*      <div className='field'>*/}
        {/*        <h3>Connect with us: </h3>*/}
        {/*        <div className='social'>*/}
        {/*          <a*/}
        {/*            target='_blank'*/}
        {/*            href={*/}
        {/*              this.state.definitons["facebook-link"] ||*/}
        {/*              "https://www.facebook.com/frameitsg"*/}
        {/*            }*/}
        {/*          >*/}
        {/*            <FacebookIcon />*/}
        {/*          </a>*/}
        {/*          <a*/}
        {/*            target='_blank'*/}
        {/*            href={*/}
        {/*              this.state.definitons["linkedin-link"] ||*/}
        {/*              "https://linkedin.com/company/frameitsg"*/}
        {/*            }*/}
        {/*          >*/}
        {/*            <LinkedInIcon />*/}
        {/*          </a>*/}
        {/*          <a*/}
        {/*            target='_blank'*/}
        {/*            href={*/}
        {/*              this.state.definitons["instragram-link"] ||*/}
        {/*              "https://www.instagram.com/frameitsg/"*/}
        {/*            }*/}
        {/*          >*/}
        {/*            <InstragramIcon />*/}
        {/*          </a>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    )}*/}
        {/*  </div>*/}
        {/*  <div className='contact-us-form login'>*/}
        {/*    <h2>Send us a message</h2>*/}

        {/*    <hr />*/}

        {/*    <div className='form'>*/}
        {/*      <div className='form-group'>*/}
        {/*        <label for='first-name'>First Name</label>*/}
        {/*        <input*/}
        {/*          data-enabled={this.state.buttonEnabled}*/}
        {/*          onKeyPress={this.handleKeyPress}*/}
        {/*          type='text'*/}
        {/*          placeholder='First Name*'*/}
        {/*          id='first-name'*/}
        {/*          defaultValue={this.state.firstName}*/}
        {/*          onChange={e => {*/}
        {/*            this.handleChange("firstName", e.target.value);*/}
        {/*          }}*/}
        {/*        />*/}
        {/*      </div>*/}
        {/*      <div className='form-group'>*/}
        {/*        <label for='last-name'>Last Name</label>*/}
        {/*        <input*/}
        {/*          data-enabled={this.state.buttonEnabled}*/}
        {/*          onKeyPress={this.handleKeyPress}*/}
        {/*          type='text'*/}
        {/*          placeholder='Last Name*'*/}
        {/*          id='last-name'*/}
        {/*          defaultValue={this.state.lastName}*/}
        {/*          onChange={e => {*/}
        {/*            this.handleChange("lastName", e.target.value);*/}
        {/*          }}*/}
        {/*        />*/}
        {/*      </div>*/}
        {/*      <div className='form-group'>*/}
        {/*        <label for='email'>Email Address</label>*/}
        {/*        <input*/}
        {/*          data-enabled={this.state.buttonEnabled}*/}
        {/*          onKeyPress={this.handleKeyPress}*/}
        {/*          type='email'*/}
        {/*          placeholder='Email Address*'*/}
        {/*          id='email'*/}
        {/*          defaultValue={this.state.email}*/}
        {/*          onChange={e => {*/}
        {/*            this.handleChange("email", e.target.value);*/}
        {/*          }}*/}
        {/*        />*/}
        {/*      </div>*/}
        {/*      <div className='form-group textarea'>*/}
        {/*        <label for='message'>Your Message</label>*/}
        {/*        <textarea*/}
        {/*          id='message'*/}
        {/*          placeholder='Your Message*'*/}
        {/*          rows='5'*/}
        {/*          onChange={e => {*/}
        {/*            this.handleChange("message", e.target.value);*/}
        {/*          }}*/}
        {/*        >*/}
        {/*          {this.state.message}*/}
        {/*        </textarea>*/}
        {/*      </div>*/}
        {/*      <WarningMessage*/}
        {/*        message={this.state.response}*/}
        {/*        success={this.state.responseSuccess}*/}
        {/*      />*/}
        {/*      <div className='options'>*/}
        {/*        <div className='clearfix'>*/}
        {/*          <button*/}
        {/*            data-enabled={this.state.buttonEnabled}*/}
        {/*            className='login-btn'*/}
        {/*            onClick={e => {*/}
        {/*              this.submitForm(e);*/}
        {/*            }}*/}
        {/*          >*/}
        {/*            Send*/}
        {/*          </button>*/}
        {/*        </div>*/}
        {/*      </div>*/}
        {/*    </div>*/}
        {/*  </div>*/}
        {/*</div>*/}
          <div className="main-container contactus">
            <div className="art-page-footer">
              <ContactUs />
              <SendUsMessages />
            </div>
          </div>
      </div>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/ContactUs.js